module.exports = __webpack_public_path__ + "img/success.855d333d.png";